<template>
    <div class="demo-bed-detail">
        <BackButton />

        <h1>{{$t('demo_beds.title')}}</h1>

        <div class="content">
            <div class="bed-info">
                <div class="mattres-container mattres-container-left">
                    <MattressAdvice :result="resultLeft" v-if="resultLeft != null"/>
                </div>
                <div class="bed">
                    <div class="pillows">
                        <img :src="'img/dna-pillow'+ (resultLeft ? resultLeft.PillowAdvice : 0) +'.svg'"
                            class="dna-pillow"
                            :class="{hidden: resultLeft == null}"
                        >
                        <img :src="'img/dna-pillow'+ (resultRight ? resultRight.PillowAdvice : 0) +'.svg'"
                            class="dna-pillow"
                            :class="{hidden: resultRight == null}"
                        >
                    </div>
                    <div class="appointment-info">
                        <div class="col">
                            <div class="name">
                                {{ leftName }}
                            </div>
                            <SleepDNA :result="resultLeft"  v-if="resultLeft != null"/>
                        </div>
                        <div class="col">
                            <div class="name">
                                {{ rightName }}
                            </div>
                            <SleepDNA :result="resultRight" v-if="resultRight != null"/>
                        </div>
                    </div>
                </div>
                <div class="mattres-container mattres-container-right">
                    <MattressAdvice :result="resultRight" v-if="resultRight != null"/>
                </div>
            </div>
            <div class="support-level">
                <div class="label">
                    {{ $t('demo_beds.support_level') }}:
                </div>
                <div class="levels">
                    <div v-for="level in 4" :key="level" class="level">
                        <div class="line"></div>
                        <button class="btn-level" :class="{selected: currentLevel == level -1}" @click="setSupportLevel(level - 1)">
                            {{level - 1}}
                        </button>
                    </div>
                </div>
                <div class="right"></div>
            </div>
        </div>
    </div>
</template>

<script>
import BackButton from "@/components/app/BackButton.vue";
import MattressAdvice from "@/components/dna/MattressAdvice.vue";
import SleepDNA from "@/components/dna/SleepDNA.vue";
import {apiStore} from "@/stores/api";
import {demobedStore} from "@/stores/demobed";

export default {
    name : "DemoBedDetail",

    components : {
        SleepDNA,
        BackButton,
        MattressAdvice
    },

    data() {
        return {
            appointment: null,
            currentLevel: 0
        };
    },

    computed: {
        bedId() {
            return demobedStore().bedId;
        },

        leftName() {
            if (this.appointment === null) {
                return null;
            }
            const client = this.appointment.clients.find(x => x.additional_info.bedside === "left");
            if (client) {
                return client.firstname;
            }
            return "";
        },

        rightName() {
            if (this.appointment === null) {
                return null;
            }
            const client = this.appointment.clients.find(x => x.additional_info.bedside === "right");
            if (client) {
                return client.firstname;
            }
            return "";
        },

        resultLeft() {
            if (this.appointment === null) {
                return null;
            }
            const client = this.appointment.clients.find(x => x.additional_info.bedside === "left");

            if (client) {
                return client.measurement_result;
            }
            return null;
        },

        resultRight() {
            if (this.appointment === null) {
                return null;
            }
            const client = this.appointment.clients.find(x => x.additional_info.bedside === "right");

            if (client) {
                return client.measurement_result;
            }
            return null;
        }
    },

    beforeUnmount() {
        this.sendZeroLevel();
    },

    async created() {
        const appointmentId = this.$route.params.appointmentId;
        this.appointment = await apiStore().getAppointment(appointmentId);
    },

    methods: {
        setSupportLevel(level) {
            this.currentLevel = level;

            const leftBaseLevels = this.getSupportData(this.resultLeft ? this.resultLeft.BaseLevels : null);
            const rightBaseLevels = this.getSupportData(this.resultRight ? this.resultRight.BaseLevels : null);

            this.sendSupportLevel(leftBaseLevels, rightBaseLevels);
        },

        sendSupportLevel(leftBaseLevels, rightBaseLevels) {
            const msg = {
                bedId: this.bedId,
                BaseLevelLeft : leftBaseLevels,
                BaseLevelRight : rightBaseLevels
            };

            demobedStore().sendSupportLevel(msg);
        },

        sendZeroLevel() {
            const msg = {
                bedId: this.bedId,
                BaseLevelLeft : this.getSupportData(null),
                BaseLevelRight : this.getSupportData(null)
            };

            demobedStore().sendSupportLevel(msg);
        },

        getSupportData(baseLevels) {
            // supportLevel 1 = P1, 2 = P3, 3 = P4
            const pLevel = this.currentLevel < 2 ? this.currentLevel : this.currentLevel + 1;
            const baseLevel = baseLevels ? baseLevels.find(x => x.BaseType === "P" + pLevel) : null;

            // get all 13 dna level values
            const levels = {};
            for (let index = 1; index <= 13; index++) {
                const value = baseLevel ? baseLevel["L" + index] : 0;
                levels[`L${index}`] = value;
            }
            return levels;
        }
    }
};
</script>

<style lang="scss" scoped>
.demo-bed-detail {
    text-align: center;
    height: 100%;

    .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 90%;
    }

    .bed-info {
        display :flex;
        flex-direction: row;
        @include slideIntroAnimation(basicSlideIntro, 450ms, 350ms);

        .bed {
            background-image: url('/img/icon-bed.svg');
            background-repeat: no-repeat;
            background-position: top center;
            width: 40%;
            height : auto;
            aspect-ratio: 112/74;

            .pillows {
                height: 20%;
                margin-top: 14%;
                display: flex;
                align-items: center;
                justify-content: center;

                .dna-pillow {
                    width: 20%;
                    margin: 0px 8.2%;

                    &.hidden {
                        opacity: 0;
                    }
                }
            }

            .appointment-info {
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-top: 12%;

                .col {
                    width : 50%;
                    text-align: center;
                    font-size: 2rem;

                    .name {
                        margin-bottom: 1rem;
                    }

                    :deep(.c-sleep-dna) {
                        transform: scale(0.8);
                    }
                }
            }
        }

        .mattres-container {
            width: 30%;
            display: flex;
            justify-content: center;
            padding-top: 3.5%;
            position: relative;

            :deep(.table) {
                transform: scale(0.8);
                max-width: 22rem;

                &:after {
                    content: ' ';
                    width : 3rem;
                    background-color: black;
                    height : 0.1rem;
                    position: absolute;

                    top: 7.1rem;
                }
            }

            &-left {
                :deep(.table) {
                    &:after {
                        right: -2.9rem;
                    }
                }
            }

            &-right {
                :deep(.table) {
                    &:after {
                        left: -2.9rem;
                    }
                }
            }
        }
    }

    .support-level {
        width: 100%;
        height : 20%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;

        margin-top: 2rem;
        font-size : 2.25rem;
        color: $color-blue;

        @include slideIntroAnimation(basicSlideIntro, 450ms, 850ms);

        .label {
            margin-right: 1rem;
            width : 33%;
            text-align: right;
        }

        .levels {
            width: 34%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            .level {
                display: flex;
                flex-direction: row;
                align-items: center;

                .line {
                    width : 2rem;
                    height: 0.25rem;
                    background-color: $color-blue;
                }

                .btn-level {
                    font-size : 2.5rem;
                    width : 5rem;
                    height: 5rem;
                    border-radius: 50%;
                    color: $color-blue;
                    background: white;
                    outline: none;
                    border: solid 0.2rem $color-blue;

                    &.selected {
                        background: $color-blue;
                        color: white;
                    }
                }
            }
        }

        .right {
            width : 33%;
        }
    }
}
</style>